exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-image[data-v-10aa8384]{position:absolute;top:-12px;right:52%}.handle[data-v-10aa8384]{position:absolute;top:-12px;left:52%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10aa8384","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/DocumentElement.vue
// module id = vk6e
// module chunks = 0